// export const isTokenExpired = (token: string | null): boolean => {
//   if (!token) return true;

//   try {
//     const payload = JSON.parse(atob(token.split(".")[1]));
//     const exp = payload.exp * 1000; // ms
//     return Date.now() > exp;
//   } catch {
//     return true;
//   }
// };

/** Returns true if the JWT is missing or past its exp claim */
export const isTokenExpired = (token: string | null): boolean => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return Date.now() > payload.exp * 1000;
  } catch {
    return true;
  }
};
 
/** Convenience: returns true when a valid, unexpired token exists */
export const isLoggedIn = (): boolean => {
  const token = localStorage.getItem("token");
  return !!token && !isTokenExpired(token);
};
 
/** Remove credentials and fire the storage event so all tabs update */
export const clearSession = (): void => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  window.dispatchEvent(new Event("storage"));
};